import React from "react";
import { useNavigate } from "react-router-dom";
import RegistrationForm from "../components/auth/RegistrationForm";

const RegisterPage = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return <RegistrationForm onBackToLogin={handleBackToLogin} />;
};

export default RegisterPage;
